import { render, staticRenderFns } from "./Adminplan.vue?vue&type=template&id=061b7e2f&scoped=true&"
import script from "./Adminplan.vue?vue&type=script&lang=js&"
export * from "./Adminplan.vue?vue&type=script&lang=js&"
import style0 from "./Adminplan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061b7e2f",
  null
  
)

export default component.exports